import { render } from "./TheHeader.vue?vue&type=template&id=177e7fc6&scoped=true"
const script = {}

import "./TheHeader.vue?vue&type=style&index=0&id=177e7fc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-177e7fc6"]])

export default __exports__